/**
 *  @fileOverview EventFilter Module, filters events in the events list based on data attributes
 *
 *  @author       Chris Hill
 *
 */

function EventFilterModule () {
  /**
   * @description Initiates filter.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */

  this.init = function () {
    buildFilters()

    var filters = document.querySelectorAll('[data-filter]')
    const results = document.querySelector('.searchResults__results')

    /**
     * Copy of the events to be reinserted when filter runs
     */
    const eCopy = results.innerHTML

    /**
     * Iterate filters and assign binding
     */
    filters.forEach((filter) => {
      if (filter.value !== undefined) {
        filter.addEventListener('change', function () {
          doFilter()
        })
      }
    })

    /**
     * @description Builds filter markup based on event parameters.
     *
     * @example
     * //
     * @returns {boolean} // null.
     */
    function buildFilters () {
      let holder = document.querySelector('[data-filters]')
      let events = document.querySelectorAll('[data-level]')
      let areas = []
      let levels = []
      let types = []
      let campuses = []

      /**
       * Iterate each event and build arrays of filter types
       */
      events.forEach((event) => {
        if (typeof event.dataset.level !== 'undefined' && event.dataset.level !== '') {
          let templevels = event.dataset.level.split('; ')
          levels = levels.concat(templevels)
        }

        if (typeof event.dataset.area !== 'undefined' && event.dataset.area !== '') {
          let tempareas = event.dataset.area.split('; ')
          areas = areas.concat(tempareas)
        }

        if (typeof event.dataset.type !== 'undefined' && event.dataset.type !== '') {
          let temptypes = event.dataset.type.split('; ')
          types = types.concat(temptypes)
        }

        if (typeof event.dataset.campus !== 'undefined' && event.dataset.campus !== '') {
          let tempcampuses = event.dataset.campus.split('; ')
          campuses = campuses.concat(tempcampuses)
        }
      })

      /**
       * Make sure arrays are unique and sorted alphabetically
       */
      levels = [...new Set(levels)].sort()
      areas = [...new Set(areas)].sort()
      types = [...new Set(types)].sort()
      campuses = [...new Set(campuses)].sort()

      /**
       * Remove global option from list
       */
      areas = areas.filter(e => e !== 'global')

      let html = ''

      html += buildHTML(levels, 'level', 'Study Level')
      html += buildHTML(areas, 'area', 'Study Area')
      html += buildHTML(types, 'type', 'Event Type')
      html += buildHTML(campuses, 'campus', 'Event Location')

      holder.innerHTML += html

      /**
       * Apply click binding to filter button to remove hidden class
       */
      var filterBtn = document.querySelector('.searchResults__filterButton')
      var filterCloseBtn = document.querySelector('.searchResults__filtersClose')

      if (filterBtn !== null) {
        filterBtn.addEventListener('click', function () {
          holder.classList.remove('searchResults__filters--mobileHidden')
        })
      }

      if (filterCloseBtn !== null) {
        filterCloseBtn.addEventListener('click', function () {
          if (!holder.classList.contains('searchResults__filters--mobileHidden')) {
            holder.classList.add('searchResults__filters--mobileHidden')
          }
        })
      }
    }

    /**
     * @description Iterates each event looking for matching filters.
     *
     * @param {Array} inArray - Array to generate HTML from.
     * @param {string} attr - Label for the data attribute.
     * @param {string} name - Name of section.
     *
     * @example
     * //
     * @returns {string} The HTML markup of the filter section.
     */
    function buildHTML (inArray, attr, name) {
      let html = ''

      /**
       * Build markup for filter
       */
      if (inArray.length > 0) {
        html += `
          <div class="searchResults__filterSection">
            <div class="searchResults__filterResetWrapper">
                <h3 class="base__heading base__heading--small">${name}</h3>
            </div>

            <ul class="searchResults__filtersList">
        `
        inArray.forEach(elm => {
          /**
           * Replace hyphens with spaces
           */
          let label = elm.replace(/-/g, ' ')

          /**
           * Remove wappa if it exists
           */
          label = label.replace(/waapa /g, '')

          /**
           * Remove campus text if it exists
           */
          label = label.replace(/ Campus/g, '')

          /**
           * Capitalise first letter of each word
           */
          label = label.split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')

          /**
           * Change Atsi Students to Aboriginal and Torres Strait Islander Students
           */
          label = label.replace(/ATSI Students/g, 'Aboriginal and Torres Strait Islander Students')

          html += `
              <li>
                  <div class="checkbox checkbox--outline">
                      <input type="checkbox" data-filter="true" data-${attr}="true" class="form__input" name="${elm}" id="${elm}" value="${elm}">
                      <label for="${elm}" class="form__label">${label}</label>
                  </div>
              </li>
          `
        })

        html += `
            </ul>
          </div>
        `
      }

      return html
    }

    /**
     * @description Iterates each event looking for matching filters.
     *
     * @example
     * //
     * @returns {boolean} // null.
     */
    let doFilter = function () {
      /**
       * Write the events back to the DOM
       */
      results.innerHTML = eCopy
      var events = results.querySelectorAll('[data-level]')

      let areas = []
      let levels = []
      let types = []
      let campuses = []
      let showAll = true
      let count = 0

      /**
       * Iterate filters and assign to area and level arrays, if checked found don't showall
       */
      filters.forEach((filter) => {
        if (filter.checked) {
          showAll = false
          if (typeof filter.dataset.level !== 'undefined') {
            levels.push(filter.value)
          }

          if (typeof filter.dataset.area !== 'undefined') {
            areas.push(filter.value)
          }

          if (typeof filter.dataset.type !== 'undefined') {
            types.push(filter.value)
          }

          if (typeof filter.dataset.campus !== 'undefined') {
            campuses.push(filter.value)
          }
        }
      })

      /**
       * Iterate each event and check against levels and areas
       */
      events.forEach((event) => {
        /**
         * Assume true and set to false if any test fails to find a match
         */
        let flag = true

        if (levels.length > 0) {
          flag = filterSearch(levels, event.dataset.level)
        }

        if (areas.length > 0 && flag) {
          flag = filterSearch(areas, event.dataset.area)
        }

        if (types.length > 0 && flag) {
          flag = filterSearch(types, event.dataset.type)
        }

        if (campuses.length > 0 && flag) {
          flag = filterSearch(campuses, event.dataset.campus)
        }

        /**
         * If not found or showall remove event from DOM
         */
        if (flag || showAll) {
          count++
        } else {
          event.remove()
        }
      })

      /**
       * Show no results msg if no events match filters
       */
      if (count === 0) {
        results.innerHTML += `
          <p>No results found.</p>
        `
      }
    }

    /**
     * @description Looks through array to determine if array value in param.
     *
     * @param {Array} inArray - Array to generate HTML from.
     * @param {string} param - Label for the data attribute.
     *
     * @example
     * //
     * @returns {boolean} The result.
     */
    function filterSearch (inArray, param) {
      let found = false
      const params = param.split('; ')

      inArray.forEach((f) => {
        params.forEach((p) => {
          if (p === f) {
            found = true
          }
        })
      })

      return found
    }
  }
}

module.exports = EventFilterModule
